module.exports = __webpack_public_path__ + "static/media/totem5.fa5958eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Totem/totem5.jpg
// module id = 363
// module chunks = 0